import dayjs from 'dayjs';
import IBundle from 'src/types/IBundle';

function isBundleAvailable(bundle: IBundle): boolean {
  return !bundle.availableTo || dayjs.unix(bundle.availableTo).isAfter(dayjs());
}

export default isBundleAvailable;
